// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bucketsStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

bucketsStyles.container = {
    gap: 0,
    css: css`
        border: 1px solid ${color("common.border")};
        padding: 15px;
        margin-bottom: 25px;
    `,
};

bucketsStyles.item = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        gap: 20px;
        > div {
            min-width: 180px;
            width: auto;
            ${xScreen("lte", "md")} {
                min-width: 170px;
            }
            ${xScreen("lte", "sm")} {
                min-width: 158px;
            }
            ${xScreen("lte", "xs")} {
                min-width: 130px;
            }
            &:last-child {
                min-width: 120px;
            }
        }
    `,
};
